import { FormControl, InputLabel, Select, MenuItem, Grid } from "@mui/material";

interface FilterSelectProps<T extends string | number> {
  label: string;
  value: T;
  options: T[];
  onChange: (value: T) => void;
}

const FilterSelect = <T extends string | number>({
  label,
  value,
  options,
  onChange,
}: FilterSelectProps<T>) => {
  return (
    <Grid item xs={10} sm={6} md={4} lg={3}>
      <InputLabel>{label}</InputLabel>
      <FormControl fullWidth size="small">
        <Select
          value={value}
          onChange={(e) => onChange(e.target.value as T)}
          label={label}
        >
          {options.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
};

export default FilterSelect;
